import React, { FC } from 'react'
import s from "./ToolbarSection.module.scss"

export interface ToolbarSectionProps{
   id?: string;
     className?: string;
     children: React.ReactNode;
}

export const ToolbarSection: FC<ToolbarSectionProps> = ({id, className="", children}) => {
  return (
      <div id={id} className={`${s.toolbarSection} ${className}`}>{children}</div>
  )
}
